// extracted by mini-css-extract-plugin
module.exports = {"root":"sd-quiz-sticky-cta_root__EpnH1","slideUp":"sd-quiz-sticky-cta_slideUp__FikIM"};